/**
 * Общие элементы HTML-оверлеев поверх холста (формы, сцены, карточки, энциклопедия):
 * настоящий текст читается экранными дикторами и масштабируется браузером на телефоне.
 */

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  style: Partial<CSSStyleDeclaration> = {},
  text?: string,
): HTMLElementTagNameMap[K] {
  const element = document.createElement(tag);
  Object.assign(element.style, style);
  if (text !== undefined) element.textContent = text;
  return element;
}

/** Затемнение на весь экран с панелью по центру. */
export function overlayRoot(): HTMLDivElement {
  return el('div', {
    position: 'fixed',
    inset: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(4, 6, 18, 0.78)',
    zIndex: '10',
    font: '16px system-ui, sans-serif',
    color: '#f2fbff',
  });
}

export function panel(width: string): HTMLDivElement {
  return el('div', {
    width: `min(${width}, calc(100vw - 32px))`,
    maxHeight: 'calc(100vh - 32px)',
    overflowY: 'auto',
    boxSizing: 'border-box',
    padding: '20px',
    borderRadius: '18px',
    background: '#0e2233',
    border: '3px solid rgba(158,220,240,.45)',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  });
}

export function button(text: string, background: string): HTMLButtonElement {
  const element = el(
    'button',
    {
      minHeight: '44px',
      padding: '0 16px',
      border: '0',
      borderRadius: '12px',
      background,
      color: '#f2fbff',
      font: '700 16px system-ui, sans-serif',
      cursor: 'pointer',
    },
    text,
  );
  element.type = 'button';
  return element;
}

/** Картинка из SVG-строки (иллюстрации собираются в коде, без внешних файлов). */
export function picture(
  svgMarkup: string,
  style: Partial<CSSStyleDeclaration> = {},
): HTMLDivElement {
  const box = el('div', { lineHeight: '0', ...style });
  box.innerHTML = svgMarkup;
  const image = box.firstElementChild as SVGElement | null;
  if (image) Object.assign(image.style, { width: '100%', height: 'auto', display: 'block' });
  return box;
}

/** Анимации выключены: настройка игрока или системная `prefers-reduced-motion` (SPEC.md, 20.5). */
export function reducedMotion(setting: 'system' | 'on' | 'off'): boolean {
  if (setting !== 'system') return setting === 'on';
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}
